import { List, ListItem, Typography } from '@mui/material'
import React from 'react'
import styles from '../../styles/pages/user/content-buyer-accounting.module.scss'
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"

const breakedownLoop = [
    {
        paymetName: "Total amount of purchases",
        paymentAmount: "800",
        status: "purchases"
    },
    {
        paymetName: "Total amount requested",
        paymentAmount: "800",
        status: "requested"
    },
    {
        paymetName: "Total amount paid",
        paymentAmount: "800",
        status: "paid"
    },
    {
        paymetName: "Total amount received",
        paymentAmount: "800",
        status: "received"
    },
    {
        paymetName: "Total amount owed",
        paymentAmount: "800",
        status: "owed"
    },
]

const assignClassname = (item) => {
    switch (item.status) {
        case "purchases":
            return styles.listPurchase
            break;
        case "requested":
            return styles.listRequest
            break;
        case "paid":
            return styles.listPaid
            break;
        case "received":
            return styles.listReceived
            break;
        case "owed":
            return styles.listOwed
            break;
        default:
            return styles.listName
            break;
    }
}

const ContentbuyerPaymentBrackdownCard = () => {
    return (
        <>
            <PerfectScrollbar className={styles.brkdownScroll}>
                <List disablePadding>
                    {breakedownLoop.map((item) => {
                        return (
                            <ListItem disablePadding className={assignClassname(item)}>
                                <Typography variant='body1'>{item?.paymetName}</Typography>
                                <Typography variant='caption'>${item?.paymentAmount}</Typography>
                            </ListItem>
                        );
                    })}
                </List>
            </PerfectScrollbar>
        </>
    )
}

export default ContentbuyerPaymentBrackdownCard